export enum APP_STATUS {
  IDLE = 'idle',
  LOADING = 'loading',
  FAILED = 'failed',
  READY = 'ready'
}

export enum APP_ERROR {
  /**
   * When the Journey is not found or can't be determined due to missing
   * details (i.e. Id not provided).
   */
  JOURNEY_NOT_FOUND = 'journey-not-found',
  /**
   * When we failed to load the design for the given Journey and there no fallback
   * is available also.
   */
  JOURNEY_DESIGN_NOT_FOUND = 'journey-design-not-found',
  /**
   * The provided token has expired.
   * Currently used by Post Qualification journeys to control the TTL of associated links.
   */
  JOURNEY_TOKEN_EXPIRED = 'journey-token-expired',
  /**
   * Indicates the Journey has been previously submitted and is restricted to a single submission.
   */
  JOURNEY_NONCE = 'journey-nonce',
  /**
   * Indicates missing or invalid context parameters.
   */
  INVALID_CONTEXT_PARAMETER = 'invalid-context-parameter'
}

export enum SUBMISSION_STATUS {
  /**
   * We haven't yet attempted to submit.
   */
  IDLE = 'idle',
  /**
   * The submission has been dispatched and we're waiting for confirmation.
   * It means we're either waiting for pre-processing or the API to respond.
   */
  LOADING = 'loading',
  /**
   * We've failed the submission, either due to an Network/API error or
   * something went wrong with our pre-processing.
   */
  FAILED = 'failed',
  /**
   * We've successfully submitted the selected Journey.
   */
  SUCCESS = 'success'
}
